import React from 'react';
import PropTypes from 'prop-types';
import { ZCDTable } from '@zencity/common-ui';

function MatrixResults(props) {
  const { data } = props;
  const { datasets, labels } = data;
  const columnArray = [
    { Header: 'Answer Option', accessor: 'label', width: false },
    ...labels.map((label, index) => ({
      Header: label,
      accessor: `values[${index}]`,
      width: false,
    })),
    { Header: 'Total', accessor: 'total', width: false },
  ];

  const tableData = datasets.map((dataset) => ({
    label: dataset.label,
    values: labels.map((_, index) => (
      <>
        {dataset.percentages[index]}%<br />
        {dataset.counts[index]}
      </>
    )),
    total: dataset.counts.reduce((sum, value) => sum + value, 0),
  }));

  return (
    <div className="engage-results-ordered-results">
      <h4 className="engage-results-engagement-screen__chart-content__subtitle">Results</h4>
      <ZCDTable columnArray={columnArray} tableData={tableData} maxItemsLimit={10} />
    </div>
  );
}

MatrixResults.propTypes = {
  data: PropTypes.shape({
    labels: PropTypes.arrayOf(PropTypes.string).isRequired,
    datasets: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        counts: PropTypes.arrayOf(PropTypes.number).isRequired,
        percentages: PropTypes.arrayOf(PropTypes.number).isRequired,
        image: PropTypes.string,
      })
    ).isRequired,
  }).isRequired,
};

export default MatrixResults;
